import React from 'react';

import { pushStateEvent } from 'constants/navigation';
import { EMPTY_FUNCTION } from 'constants/misc';

function Link({ children, href, onClick, ...rest}) {
  const handleClick = event => {
    event.preventDefault();
    window.history.pushState(null, null, event.target.pathname);
    window.dispatchEvent(pushStateEvent);
    onClick(event);
  };

return <a href={href} onClick={handleClick} {...rest}>{children}</a>
}

Link.defaultProps = {
  onClick: EMPTY_FUNCTION,
}

export default Link;
